export default __webpack_public_path__ + "static/media/arrow-right.19491e6a.svg";